import { useStyles } from './styles'
import Break from '@/shared/ui/break'
import { useUnit } from 'effector-react'
import { $externalProfile, $gamedId, $userBalance, $userLanguage } from '@/entities/user'
import { $premiumLevel } from '@/entities/user'
import { $steamUserData } from '@/entities/platforms/steam/store'
import { GigiBalance } from '../gigiBalance'
import { BalanceText } from '@/shared/ui/balanceText'
import { lang } from '@/shared/constants/lang'
import { AppButton } from '@/shared/ui/button'
import { Icon } from '@/shared/ui/icon'
import { useFriendAction } from '@/pages/externalUnifiedProfile/hooks/useFriendAction'
import { $externalUserTid } from '@/entities/navigation/store'
import { usePostStory } from '@/shared/hooks/usePostStory'
import WebApp from '@twa-dev/sdk'
import { AppAvatar } from '@/shared/ui/appAvatar'
import useFormatUnifiedStats from '@/pages/unifiedProfilePage/hooks/useFormatUnifiedStats'
import { useMemo } from 'react'

type ProfileCardProps = {
  username?: string
  balance: number
  variant?: 'profile' | 'default' | 'external' | 'external_private'
  xtGamedId?: string
}

export const ProfileCard = (props: ProfileCardProps) => {
  const userData = useUnit($steamUserData)?.userData
  const gamedId = useUnit($gamedId)
  const userLang = useUnit($userLanguage)
  const externalProfile = useUnit($externalProfile)
  const gamedBalance = useUnit($userBalance)

  const formattedUnifiedStats = useFormatUnifiedStats()
  const TVGA = useMemo(() => {
    console.log(formattedUnifiedStats)
    if (!formattedUnifiedStats.length) {
      return 0
    }
    return formattedUnifiedStats[0].value
  }, [formattedUnifiedStats])
  const friendTid = useUnit($externalUserTid)
  const isMe = friendTid === WebApp?.initDataUnsafe?.user?.id

  const { handleShareStory, isMakingStoryLink } = usePostStory()
  const isFriend = externalProfile?.is_friend
  const subscriptionLevel = useUnit($premiumLevel)
  const { username, balance, variant = 'default' } = props
  const { handleFriendAction, isLoading } = useFriendAction(isFriend!, friendTid)
  const _usrname = userData?.name ?? username
  const { classes } = useStyles()
  const text = lang[userLang].pages.profile

  if (variant === 'default')
    return (
      <div className={classes.root}>
        <div className={classes.nicknameAndPfpWrapper}>
          <AppAvatar
            src={userData?.photoUrl ?? ''}
            iconWidth={24}
            iconStyles={{ right: '-8px', bottom: '-8px' }}
            subscriptionLevel={subscriptionLevel}
            width={72}
          />
          <div className={classes.nicknameAndIdWrapper}>
            <span className={classes.username}>{_usrname}</span>
            <span className={classes.id}>GAMED ID: {gamedId}</span>
          </div>
        </div>
        <Break />
        <div className={classes.rewardWrapper}>
          <GigiBalance
            balance={balance}
            textJustifyContent="center"
            modalStyles={{ width: '95%', paddingLeft: '5%' }}
          />
        </div>
      </div>
    )
  if (variant === 'profile')
    return (
      <div className={classes.root}>
        <div className={classes.nicknameAndPfpWrapper}>
          <AppAvatar
            src={userData?.photoUrl ?? ''}
            iconWidth={24}
            iconStyles={{ right: '-8px', bottom: '-8px' }}
            subscriptionLevel={subscriptionLevel}
            width={72}
          />
          <div className={classes.nicknameAndIdWrapper}>
            <span className={classes.username}>{_usrname}</span>
            <span className={classes.id}>GAMED ID: {gamedId}</span>
            <GigiBalance
              variant="profile"
              balance={balance}
              textJustifyContent="center"
              modalStyles={{ width: '95%', paddingLeft: '5%' }}
            />
          </div>
        </div>
        <Break />
        <div className={classes.balancesWrapper}>
          <div className={classes.balance}>
            <p>{text.totalAssets}</p>
            <BalanceText
              view="dollar"
              balance={TVGA}
              textSize="s"
              iconSize={12}
            />
          </div>
          <div className={classes.balance}>
            <p>{text.rewards}</p>
            <BalanceText
              view="gamed"
              balance={gamedBalance}
              textSize="s"
              iconSize={24}
            />
          </div>
        </div>
        <AppButton
          onClick={handleShareStory}
          isLoading={isMakingStoryLink}
          fullWidth
          className={classes.shareButton}
        >
          <Icon view="share" />
          {text.shareLegacy}
        </AppButton>
      </div>
    )
  if (variant === 'external' || variant === 'external_private') {
    return (
      <div className={classes.root}>
        <div className={classes.nicknameAndPfpWrapper}>
          <AppAvatar
            src={externalProfile?.avatar ?? ''}
            iconWidth={24}
            iconStyles={{ right: '-8px', bottom: '-8px' }}
            subscriptionLevel={externalProfile?.premium_level ?? 0}
            width={72}
          />
          <div className={classes.nicknameAndIdWrapper}>
            <span className={classes.username}>{externalProfile?.username}</span>
            <span className={classes.id}>GAMED ID: {variant === 'external' ? props.xtGamedId : 'XXXXXX'}</span>
            <GigiBalance
              variant="profile"
              balance={balance}
              textJustifyContent="center"
              modalStyles={{ width: '95%', paddingLeft: '5%' }}
            />
          </div>
        </div>
        {!isMe && (
          <AppButton
            fullWidth
            isLoading={isLoading}
            onClick={handleFriendAction}
            style={isFriend ? { background: 'rgba(255, 255, 255, 0.16)', backdropFilter: 'blur(16px)' } : {}}
            className={classes.shareButton}
          >
            <Icon
              view={isFriend ? 'removeFriend' : 'addFriend'}
              width={32}
            />
            {isFriend ? text.removeFriend : text.addFriend}
          </AppButton>
        )}
      </div>
    )
  }
}
